export function getApiErrorMessage(error, fallback = "请求失败，请稍后重试") {
  if (!error?.response) {
    return "无法连接服务器，请检查后端服务与网络配置";
  }

  const status = Number(error.response.status || 0);
  if (status === 405) {
    return "当前接口不支持该请求方法，请确认后端版本或代理目标是否正确";
  }
  if ([502, 503, 504].includes(status)) {
    return "后端网关暂不可用，请检查 API 服务或反向代理上游状态";
  }

  const data = error.response.data;
  if (typeof data === "string" && data.trim()) {
    if (/<html[\s>]|<!doctype html|<body[\s>]/i.test(data)) {
      return "后端返回了 HTML 错误页，请检查 API 网关或代理配置";
    }
    return data;
  }
  if (typeof data?.detail === "string") return data.detail;
  if (Array.isArray(data?.non_field_errors)) return data.non_field_errors.join("；");

  if (data && typeof data === "object") {
    const firstFieldError = Object.values(data).find(
      (value) => typeof value === "string" || Array.isArray(value),
    );
    if (typeof firstFieldError === "string") return firstFieldError;
    if (Array.isArray(firstFieldError)) return firstFieldError.join("；");
  }

  return fallback;
}
